import { render, staticRenderFns } from "./PinboardListCard.vue?vue&type=template&id=28d168fd&scoped=true&"
import script from "./PinboardListCard.vue?vue&type=script&lang=ts&"
export * from "./PinboardListCard.vue?vue&type=script&lang=ts&"
import style0 from "./PinboardListCard.vue?vue&type=style&index=0&id=28d168fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d168fd",
  null
  
)

export default component.exports